import React from 'react';
import './BackgroundLayout.css';

/**
 * BackgroundLayout - Premium Enterprise SaaS Background Wrapper
 * Provides a layered, immersive background for authentication pages.
 */
export default function BackgroundLayout({ children }) {
    return (
        <div className="bg-layout-root">
            {/* Visual background layers */}
            <div className="bg-layer bg-base" />
            <div className="bg-layer bg-grid" />
            <div className="bg-layer bg-glow" />

            {/* Animated Floating Blobs */}
            <div className="bg-layer bg-blob bg-blob-blue" />
            <div className="bg-layer bg-blob bg-blob-purple" />
            <div className="bg-layer bg-blob bg-blob-cyan" />

            {/* Finishing textures */}
            <div className="bg-layer bg-noise" />

            {/* Centered content wrapper */}
            <div className="bg-content-container">
                {children}
            </div>
        </div>
    );
}
